import React, { useEffect, useState } from "react";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import PageSerch from "../SerchDocters/Components/PageSerch";
import { oneKlicks } from "../../../SDK/oneclick";
import Paginationnew from "../../../Uitiles/Paginationnew";
import { encryptId } from "../../../services/apiService";
import { Link } from "react-router-dom";


const PharmacyList = () => {

    const [pharmacies, setPharmacies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('newest');
    const [sortOrder, setSortOrder] = useState('asc');
    const [view, setView] = useState('list');

    useEffect(() => {
        getPharmacies();
    }, []);

    useEffect(() => {
        getPharmacies();
    }, [currentPage, search]);


    const getPharmacies = async () => {
        setLoading(true);
        setError(null);

        try {
            const tableSchema = '';
            const tableName = 'pharmacies';
            const conditions = {};

            // Search functionality
            const searchObject = search.trim() ? {
                name: search,
                email: search,
                phone: search,
                display_name: search,
                address: search,
                status: search,
                country: search
            } : {};

            // Order by newest first
            const orderBy = 'created_at DESC';
            const pagination = { page: currentPage, limit: perPage };
            const margedata = '';

            const pharmacies = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, searchObject, pagination, margedata);
            console.log('getPharmacies pharmacies', pharmacies);

            if (pharmacies.success === true) {
                setPharmacies(pharmacies.data || []);
                setTotalPages(pharmacies.totalPages || 1);
            } else {
                setError(pharmacies.message || 'Failed to fetch pharmacies');
                setPharmacies([]);
            }
        } catch (error) {
            console.error('Error fetching pharmacies:', error);
            setError('Failed to fetch pharmacies');
            setPharmacies([]);
        } finally {
            setLoading(false);
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log('handlePageChange page', page);
    }

    return (
        <>
            <PageSerch />
            <DynamicBreadcrumbs />

            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="container">
                    <div className="dc-haslayout page-data dc-parent-section dc-enabled">
                        <div className="main-page-wrapper">
                            <div className="dc-runner">
                                <div className="dc-runner-content">
                                    <div className="dc-runner-heading">
                                        <h3>Store List</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-12 col-lg-8 order-first  page-section twocolumn-page-section">

                                    <div className="dc-description">
                                        <div id="dokan-store-listing-filter-wrap">
                                            <div className="left">
                                                <p className="item store-count">
                                                    Total store showing: {pharmacies.length}        </p>
                                            </div>

                                            <div className="right">
                                                <div className="item">
                                                    <div className="dokan-icons">
                                                        <div className="dokan-icon-div"></div>
                                                        <div className="dokan-icon-div"></div>
                                                        <div className="dokan-icon-div"></div>
                                                    </div>

                                                    <button className="dokan-store-list-filter-button dokan-btn dokan-btn-theme">
                                                        Filter
                                                    </button>
                                                </div>

                                                <form name="stores_sorting" className="sort-by item" method="get">
                                                    <label>Sort by:</label>

                                                    <select name="stores_orderby" id="stores_orderby" aria-label="Sort by">
                                                        <option value="most_recent" selected="selected">Most Recent</option>
                                                        <option value="total_orders">Most Popular</option>
                                                        <option value="random">Random</option>
                                                    </select>
                                                </form>

                                                <div className="toggle-view item">
                                                    <span className={`dashicons dashicons-screenoptions ${view === 'grid' ? 'active' : ''}`} data-view="grid-view" onClick={() => setView('grid')}></span>
                                                    <span className={`dashicons dashicons-menu-alt ${view === 'list' ? 'active' : ''}`} data-view="list-view" onClick={() => setView('list')}></span>
                                                </div>
                                            </div>
                                        </div>


                                        <form role="store-list-filter" method="get" name="dokan_store_lists_filter_form" id="dokan-store-listing-filter-form-wrap" style={{ display: 'none' }}>

                                            <div className="store-search grid-item">
                                                <input
                                                    type="search"
                                                    className="store-search-input"
                                                    name="dokan_seller_search"
                                                    placeholder="Search Pharmacies"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                            <div className="apply-filter">
                                                <button id="cancel-filter-btn" className="dokan-btn dokan-btn-theme">Cancel</button>
                                                <button id="apply-filter-btn" className="dokan-btn dokan-btn-theme" type="submit">Apply</button>
                                            </div>

                                            <input type="hidden" id="_store_filter_nonce" name="_store_filter_nonce" value="473270e935" />
                                        </form>
                                        <div id="dokan-seller-listing-wrap" className={view === 'grid' ? 'grid-view' : 'list-view'}>
                                            {loading && (
                                                <div className="loading-container" style={{ textAlign: 'center', padding: '20px' }}>
                                                    <p>Loading pharmacies...</p>
                                                </div>
                                            )}

                                            {error && (
                                                <div className="error-container" style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                                                    <p>Error: {error}</p>
                                                </div>
                                            )}

                                            {!loading && !error && pharmacies.length === 0 && (
                                                <div className="no-results" style={{ textAlign: 'center', padding: '20px' }}>
                                                    <p>No pharmacies found.</p>
                                                </div>
                                            )}

                                            {!loading && !error && pharmacies.length > 0 && (
                                                <div className="seller-listing-content">
                                                    <ul className="dokan-seller-wrap">

                                                        {pharmacies.map((pharmacy, index) => (
                                                            <li key={pharmacy.id} className={`dokan-single-seller woocommerce coloum-3 no-banner-img`}>
                                                                <div className="store-wrapper">
                                                                    <div className="store-header">
                                                                        <div className="store-banner">
                                                                            <a href={`/pharmacy?id=${encryptId(pharmacy.id)}`}>
                                                                                <img
                                                                                    decoding="async"
                                                                                    src={pharmacy.photos && pharmacy.photos.length > 0
                                                                                        ? pharmacy.photos[0]
                                                                                        : "//css.meddylist.com//wp-content/plugins/dokan-lite/assets/images/default-store-banner.png"
                                                                                    }
                                                                                    alt={pharmacy.name}
                                                                                />
                                                                            </a>
                                                                        </div>
                                                                    </div>

                                                                    <div className="store-content default-store-banner">
                                                                        <div className="store-data-container">
                                                                            {view === 'list' && (

                                                                                <div className="featured-favourite">
                                                                                    {pharmacy.rating && (
                                                                                        <div className="rating">
                                                                                            <span className="stars">
                                                                                                {[...Array(5)].map((_, i) => (
                                                                                                    <span key={i} className={`star ${i < Math.floor(pharmacy.rating) ? 'filled' : ''}`}>
                                                                                                        ★
                                                                                                    </span>
                                                                                                ))}
                                                                                            </span>
                                                                                            <span className="rating-text">({pharmacy.user_ratings_total || 0} reviews)</span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {view === 'grid' && (
                                                                                <div className="store-data" style={{ height: '20px' }}>

                                                                                </div>
                                                                            )}

                                                                            <div className="store-data">
                                                                                {/* pharmacy.name  max 3 lines after that show ... */}
                                                                                <h2><Link to={`/pharmacy?id=${encryptId(pharmacy.id)}`} style={{ textAlign: 'start', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>{pharmacy.name}</Link></h2>
                                                                                {pharmacy.formatted_address && (
                                                                                    <p className="address">{pharmacy.formatted_address}</p>
                                                                                )}
                                                                                {pharmacy.phone && (
                                                                                    <p className="phone">{pharmacy.phone}</p>
                                                                                )}
                                                                                {pharmacy.license_number && (
                                                                                    <p className="license">License: {pharmacy.license_number}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="store-footer">
                                                                        <div className="seller-avatar">
                                                                            <Link to={`/pharmacy?id=${encryptId(pharmacy.id)}`}>
                                                                                <img
                                                                                    decoding="async"
                                                                                    src={pharmacy.photos && pharmacy.photos.length > 0
                                                                                        ? pharmacy.photos[0]
                                                                                        : "https://secure.gravatar.com/avatar/89220643b4b152cc02b1581302740046?s=96&d=mm&r=g"
                                                                                    }
                                                                                    alt={pharmacy.name}
                                                                                    size="150"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <Link to={`/pharmacy?id=${encryptId(pharmacy.id)}`} title="Visit Store">
                                                                            <span className="dashicons dashicons-arrow-right-alt2 dokan-btn-theme dokan-btn-round"></span>
                                                                        </Link>
                                                                        {view === 'grid' && (
                                                                            <div className="featured-favourite">
                                                                                {pharmacy.rating && (
                                                                                    <div className="rating">
                                                                                        <span className="stars">
                                                                                            {[...Array(5)].map((_, i) => (
                                                                                                <span key={i} className={`star ${i < Math.floor(pharmacy.rating) ? 'filled' : ''}`}>
                                                                                                    ★
                                                                                                </span>
                                                                                            ))}
                                                                                        </span>
                                                                                        <span className="rating-text">({pharmacy.user_ratings_total || 0} reviews)</span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}

                                                        <div className="dokan-clearfix"></div>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    {/* currentPage, totalPages, handlePageChange */}
                                    <Paginationnew currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                                </div>
                                <div className="col-12 col-md-12 col-lg-4 dc-sidebar-grid mt-lg-0 order-last">
                                    <aside id="dc-sidebar" className="dc-sidebar">
                                        <div id="doctreat_apps-3" className="dc-widget dc-sidebarapps dc-widget dc-mobileappoptions widget_categories">
                                            <figure className="dc-appimgs">
                                                <img width="" height="" src={require('../../../assets/images/sidebar02.jpg')} alt="App downloads" />
                                            </figure>
                                            <div className="dc-mobileapp-content">
                                                <div className="dc-title">
                                                    <h3>
                                                        <span>Care On The GO</span>	Get Mobile App
                                                    </h3>
                                                </div>
                                                <div className="dc-description">
                                                    <p>A dipisicing sed dotem eiusmou tempor incididunt ut labore</p>
                                                </div>
                                                <div className="dc-appemail-form">
                                                    <input type="email" name="app_email" value="" className="form-control" placeholder="Email ID" required="" />
                                                    <button type="submit" className="dc-get-app"><i className="fa fa-paper-plane"></i></button>
                                                </div>
                                            </div>

                                        </div>
                                        <div id="doctreat_adds-4" className="dc-widget dc-sidebaradds dc-searchresultad widget_categories">
                                            <img src={require('../../../assets/images/img-02.jpg')} alt="" />
                                        </div>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </>
    );
};

export default PharmacyList;
